module.exports = __webpack_public_path__ + "resources/img/appstore.3aa3b816.png";